module.exports = __webpack_public_path__ + "img/QRCode1.228ab7d6.jpeg";